import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import { coupon_type_enums } from "shared/utils/constants";
import styles from "./style.module.scss";

interface PromoDetailsModalProps {
  promoDetails: any;
  isOpen: boolean;
  closeModal: any;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PromoDetailsModal = ({
  promoDetails,
  isOpen,
  closeModal,
}: PromoDetailsModalProps) => {
  const isFlatType = Number(promoDetails?.type) === coupon_type_enums.flat;

  return (
    <div>
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeModal}
        fullWidth
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className={styles.dialogContent}>
          <div className={styles.crossIcon}>
            <Icons.CrossIcon onClick={() => closeModal()} />
          </div>

          <div className={styles.title}>Coupon Details</div>

          <div className={styles.promoCodeWrapper}>
            <div className={styles.promoCode}>{promoDetails?.code}</div>
          </div>

          <div className={styles.status}>
            Status:{" "}
            <span
              className={`${styles.statusBadge} ${
                promoDetails?.is_active ? styles.active : styles.inactive
              }`}
            >
              {promoDetails?.is_active ? "Active" : "Inactive"}
            </span>
          </div>

          <DialogContentText id="alert-dialog-slide-description">
            <div className={styles.promoInfoWrapper}>
              <div>
                <div className={styles.label}>Coupon Type:</div>
                <div className={styles.value}>
                  {isFlatType
                    ? "Flat student per month price"
                    : "Percentage discount"}
                </div>
              </div>
              <div>
                <div className={styles.label}>
                  {isFlatType
                    ? "Flat Student Per Month Price:"
                    : "Discount Percentage:"}
                </div>
                <div className={styles.value}>
                  {isFlatType
                    ? `Rs. ${promoDetails?.flat_spmp}`
                    : `${promoDetails?.discount_percentage}%`}
                </div>
              </div>
              <div>
                <div className={styles.label}>Total Quantity:</div>
                <div className={styles.value}>{promoDetails?.quantity}</div>
              </div>
              <div>
                <div className={styles.label}>Used Quantity:</div>
                <div className={styles.value}>
                  {promoDetails?.used_quantity}
                </div>
              </div>
              <div>
                <div className={styles.label}>Remaining Quantity:</div>
                <div className={styles.value}>
                  {promoDetails?.quantity - promoDetails?.used_quantity}
                </div>
              </div>
            </div>

            <div className={styles.divider} />

            <h4 className={styles.heading}>Validity Period</h4>
            <div className={styles.promoInfoWrapper}>
              <div>
                <div className={styles.label}>Start Date:</div>
                <div className={styles.value}>
                  {promoDetails?.created_at
                    ? new Date(promoDetails.created_at).toLocaleDateString()
                    : "Not Provided"}
                </div>
              </div>
              <div>
                <div className={styles.label}>Expiry Date:</div>
                <div className={styles.value}>
                  {promoDetails?.expiry_date
                    ? new Date(promoDetails.expiry_date).toLocaleDateString()
                    : "Not Provided"}
                </div>
              </div>
              <div>
                <div className={styles.label}>Days Remaining:</div>
                <div className={styles.value}>
                  {promoDetails?.expiry_date
                    ? Math.max(
                        0,
                        Math.ceil(
                          (new Date(promoDetails.expiry_date).getTime() -
                            new Date().getTime()) /
                            (1000 * 60 * 60 * 24)
                        )
                      )
                    : "Not Provided"}{" "}
                  days
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PromoDetailsModal;
